var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{attrs:{"id":"savingMessage"}},[_vm._v("Guardando tu información")]),_vm._v(" "),_c('div',{staticClass:"pro-bar-container"},[_c('div',{staticClass:"pro-bar pro-bar-width",attrs:{"data-pro-bar-percent":"80"}},[_c('div',{staticClass:"pro-bar-candy"})])])])
}]

export { render, staticRenderFns }